module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/day03_09_stay-03c260478c365ad202cbff9a33efbdf7.jpg";